export enum GraphType {
  ANALOG,
  DIGITAL,
}
